import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { api } from "../../api/api";
import { Button } from "@mui/material";
import CreateModal from "./CreatePackagesModal";

type Props = {};

const Packages = (props: Props) => {
  const [rows, setRows] = useState<any[]>([]);
  const [modalConfig, setModalConfig] = useState<{
    data?: any;
    open: boolean;
  }>();

  const [total, setTotal] = useState();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [sortModel, setSortModel] = useState<any>([]);
  const [search, setSearch] = useState("");

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const fetcher = async () => {
    api
      .get(
        //@ts-ignore
        `/packages?limit=${paginationModel.pageSize}&page=${
          paginationModel.page
        }${
          sortModel && sortModel.length > 0
            ? `&sortOrder=${sortModel[0].sort}&sortField=${sortModel[0].field}`
            : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then((res) => {
        setTotal(res.data.count);
        setRows(res.data.packages);
      });
  };

  useEffect(() => {
    fetcher();
  }, [paginationModel, sortModel, search]);

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 50 },
    { field: "name", headerName: "Name", width: 180 },
    { field: "service_name", headerName: "Service", width: 180 },
    { field: "price", headerName: "Price", width: 100 },
    { field: "service_qty", headerName: "Session Qty", width: 120 },
    {
      field: "period_days",
      headerName: "Validity (days)",
      width: 130,
      renderCell: ({ value }) => (value ?? "-"),
    },
    {
      field: "actions",
      headerName: "",
      width: 200,
      renderCell: ({ row }) => {
        return (
          <>
            <Button
              variant="contained"
              color="error"
              sx={{ mr: "10px" }}
              onClick={() => {
                api.delete(`/packages/${row.id}`).then((res) => {
                  fetcher();
                });
              }}
            >
              Delete
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={() => setModalConfig({ data: row, open: true })}
            >
              Edit
            </Button>
          </>
        );
      },
    },
  ];

  const handleClose = () => {
    setModalConfig((prev) => {
      return { data: undefined, open: false };
    });
  };

  return (
    <>
      <Button onClick={() => setModalConfig({ open: true })}>
        Create Package
      </Button>
      <div className="input_wrapper">
        <input placeholder="Search..." onKeyUp={handleSearch} />
      </div>
      <DataGrid
        rows={rows}
        columns={columns}
        onPaginationModelChange={setPaginationModel}
        rowCount={total}
        paginationModel={paginationModel}
        onSortModelChange={setSortModel}
        pageSizeOptions={[5, 10]}
        sx={{ border: 0, height: "86%" }}
        pagination
        sortingMode="server"
        paginationMode="server"
      />

      {modalConfig?.open && modalConfig && (
        <CreateModal
          modalConfig={modalConfig as any}
          handleClose={handleClose}
          fetcher={fetcher}
          setModalConfig={setModalConfig}
        />
      )}
    </>
  );
};

export default Packages;
